export default __webpack_public_path__ + "static/media/flag-ar.f3d773c7.svg";